// Report filter configurations - defines which filters are used by each report type

export const REPORT_FILTER_CONFIGS = {
	salesAnalysis: [
		'dateRange',
		'customers',
		'salespeople',
		'businessTypes',
		'groups',
		'items',
		'productCategories',
		'companies',
	],

	companyBreakdownSales: [
		'dateRange',
		'customers',
		'salespeople',
		'businessTypes',
		'groups',
		'items',
		'productCategories',
		'companies',
	],

	customerAnalytics: [
		'dateRange',
		'customers',
		'leadOrCustomer',
		'groups',
		'businessTypes',
		'items',
		'productCategories',
		'companies',
	],

	inventoryReports: [
		'dateRange',
		'items',
		'productCategories',
		'warehouses',
		'companies',
	],

	territoryAnalysis: ['dateRange', 'customers', 'salespeople', 'companies'],

	activeOrders: [
		'dateRange',
		'customers',
		'salespeople',
		'businessTypes',
		'groups',
		'items',
		'productCategories',
		'companies',
	],

	clientPaymentStatus: [
		'dateRange',
		'customers',
		'salespeople',
		'businessTypes',
		'groups',
		'items',
		'productCategories',
		'companies',
	],

	kpiOverview: [
		'dateRange',
		'customers',
		'salespeople',
		'businessTypes',
		'groups',
		'items',
		'productCategories',
		'teams',
		'companies',
	],

	salesPipeline: [
		'dateRange',
		'opportunityStages',
		'salespeople',
		'businessTypes',
		'companies',
	],

	goalsTable: ['dateRange', 'salespeople', 'teams', 'companies'],

	accountsReceivableAging: [
		'customers',
		'salespeople',
		'businessTypes',
		'groups',
		'companies',
	],

	taxSummary: ['dateRange', 'customers', 'companies'],

	cashReceipts: [
		'dateRange',
		'customers',
		'salespeople',
		'companies',
		'transactionStatus',
	],

	grossProfitDetail: [
		'dateRange',
		'customers',
		'salespeople',
		'businessTypes',
		'groups',
		'items',
		'productCategories',
		'companies',
	],

	creditManagement: [
		'customers',
		'salespeople',
		'businessTypes',
		'groups',
		'companies',
	],

	quoteItemDemandSummary: [
		'dateRange',
		'customers',
		'salespeople',
		'businessTypes',
		'groups',
		'companies',
	],

	quoteDemandByCustomer: [
		'dateRange',
		'customers',
		'salespeople',
		'businessTypes',
		'groups',
		'companies',
	],

	// No dateRange — saved prices are a current-state concept, not period-based.
	customerSavedPrices: [
		'customers',
		'salespeople',
		'businessTypes',
		'groups',
		'companies',
	],

	promoRedemptions: ['dateRange', 'customers', 'companies'],
} as const;
